'use strict'

module.exports = (function () {
    /**
    * @ngdoc method
    * @name fixedTitleBar
    * @description Initializes a fixed title bar that activates on scroll
    **/

    // Needs only be initialized once per page
    var initialize = function (options) {
        var $body = $('body');
        var contentType = $body.attr('data-doctype');

        if (options && Array.isArray(options.disabledContentTypes) && contentType && options.disabledContentTypes.includes(contentType)) {
            return;
        }

        $(window).on('scroll', function (e) {
            if ($(window).scrollTop() > 50) {
                $body.addClass('has-fix-strip');
            } else {
                $body.removeClass('has-fix-strip');
            }
        });
    };

    // Return an object exposing the public items
    return {
        initialize: initialize
    };
}())